// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"492":"cc8f3f88","825":"a3205a42","872":"6f348ad4"}[chunkId] + ".chunk.js";
};